import { render, staticRenderFns } from "./headnav.vue?vue&type=template&id=2a88ea02&scoped=true"
import script from "./headnav.vue?vue&type=script&lang=js"
export * from "./headnav.vue?vue&type=script&lang=js"
import style0 from "./headnav.vue?vue&type=style&index=0&id=2a88ea02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88ea02",
  null
  
)

export default component.exports